import Input, { TextTypes } from '@root/core/src/components/input';
import MaskedInput from '@root/vendor/react-text-mask';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { PHONE_NUMBER_MASK, cleanPhoneNumberValue } from '@root/core/src/models/phone';
import { StyleSheet } from '@root/core/src/utils/styles';

export function PhoneNumberInput({
  errorLabel, icon, inputId, inputMask, inputRef, label, onBlur, onChange, value,
}) {
  const handleChange = (newValue) => {
    const cleanedPhoneNumber = cleanPhoneNumberValue(newValue);
    onChange(cleanedPhoneNumber);
  };

  const handleBlur = (v) => onBlur && onBlur(v);

  const renderInput = (ref, props) => {
    const attachRefs = (el) => {
      ref(el);

      if (typeof inputRef === 'function') { inputRef(el); } else if (inputRef) { inputRef.current = el; }
    };

    return (
      <Input
        icon={icon}
        inputType={TextTypes.TEL}
        label={label}
        ref={attachRefs}
        {...props}
      />
    );
  };

  return (
    <div css={styles.wrapper}>
      <MaskedInput
        errorLabel={errorLabel}
        id={inputId}
        mask={inputMask}
        onBlur={handleBlur}
        onChange={handleChange}
        render={renderInput}
        type={TextTypes.TEL}
        value={value || ''}
      />
    </div>
  );
}

PhoneNumberInput.propTypes = {
  errorLabel: PropTypes.string,
  icon: PropTypes.node,
  inputId: PropTypes.string,
  inputMask: PropTypes.array,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  label: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

PhoneNumberInput.defaultProps = {
  inputMask: PHONE_NUMBER_MASK,
};

export default React.forwardRef((props, ref) => (
  <PhoneNumberInput
    {...props}
    inputRef={ref}
  />
));

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: 65,
    position: 'relative',
  },
});
